import styled from 'styled-components';
import {Typography, typographyStyle} from '@/components/Typography';
import {Flexbox, IconClose} from '@/styled-components';
import {interceptProps} from '@/styled-components/utils';
import {palette} from '@/styles';
import FocusImg from './assets/focus.svg';

export const SectionBlock = styled.div`
  padding: 20px 16px;
  background-color: ${palette.white};
`;

export const SectionTitle = styled(Typography).attrs({
  variant: 'medium14',
  color: palette.textPrimary,
})`
  font-weight: 700;
`;

export const SectionSubTitle = styled(Typography).attrs({
  variant: 'medium12',
  color: palette.gray400,
})`
  font-weight: 500;
`;

export const ValueText = styled(Typography).attrs({
  variant: 'medium12',
  color: palette.textPrimary,
})`
  font-weight: 700;
`;

export const SubValueText = styled(Typography).attrs({
  variant: 'medium10',
  color: palette.gray500,
})`
  font-weight: 500;
`;

export const GrayBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  background-color: ${palette.gray100};
  gap: 12px;
  border-radius: 5px;
`;

export const GrayCenterBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  background-color: ${palette.gray100};
  gap: 6px;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
`;

export const GrayBorderBox = styled.div`
  padding: 12px;
  background-color: ${palette.white};
  border: solid 1px ${palette.gray150};
  border-radius: 5px;
`;

export const Chips = styled.div`
  display: flex;
  flex-grow: 1;
  padding: 8px 16px;
  overflow: auto;
  gap: 4px;
`;

export const FocusIcon = styled('img').attrs({
  src: FocusImg,
})`
  cursor: pointer;
`;

export const Chip = styled(Flexbox)`
  border: solid 1px ${palette.gray200};
  color: ${palette.gray800};
  padding: 7px 12px;
  border-radius: 24px;
  white-space: nowrap;
  gap: 4px;
  ${{...typographyStyle.medium12}}
  ${IconClose} {
    cursor: pointer;
  }
`;

export const StatusBar = styled.div`
  padding-top: 12px;
  flex-shrink: 0;
  ${{...typographyStyle.medium14}}
`;

export const Footer = styled.div`
  flex-shrink: 0;
  padding: 6px 16px 12px;
`;

export const SectionTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const SectionTab = styled('div').withConfig({
  shouldForwardProp: interceptProps(['active']),
})<{
  active?: boolean;
}>`
  background-color: ${palette.gray100};
  color: ${palette.gray800};
  padding: 8px 12px;
  border-radius: 24px;
  white-space: nowrap;
  cursor: pointer;
  ${{...typographyStyle.medium12}}
  ${({active}) =>
    active &&
    `background-color: ${palette.primary400}; color: ${palette.white};`}
`;

export const HighlightBox = styled.div`
  border-radius: 5px;
  padding: 8px;
  border: 1px solid ${palette.primary200};
  outline: 3px solid ${palette.primary100};
  color: ${palette.gray600};
`;

export const ChartTitle = styled(Typography).attrs({
  variant: 'medium14',
  color: palette.gray600,
})`
  font-weight: 500;
`;
